/* ==========================================================================
   Customer Preferences
   ========================================================================== */
(function () {
  'use strict';

  // ---------- Config & State ----------
  const DEBOUNCE_MS = 1200;
  const root = document.querySelector('[data-customer-preferences]');
  if (!root) return;

  const CONFIG = {
    email: root.dataset.customerEmail || '',
    customerGid: root.dataset.customerGid || '',
    region: root.dataset.customerRegion || 'US',
    webhookUrl: root.dataset.webhookUrl || '',
    marketingWebhookUrl: root.dataset.marketingWebhookUrl || '',
  phoneWebhookUrl: root.dataset.phoneWebhookUrl || '',
    popupEnabled: root.dataset.popupEnabled === 'true',
  };

  const overlay = document.getElementById('preference-popup-overlay');
  const views = {
    confirmSubscribe: document.getElementById('preference-popup-confirmation-subscribe'),
    confirmUnsubscribe: document.getElementById('preference-popup-confirmation-unsubscribe'),
    successSubscribe: document.getElementById('preference-popup-success-subscribe'),
    successUnsubscribe: document.getElementById('preference-popup-success-unsubscribe'),
  };

  let activeCheckbox = null;
  let pendingSubscribing = false;
  let syncing = false;
  let webhookTimer = null;

  // ---------- Utilities ----------
  const $$ = (sel, ctx = document) => Array.from(ctx.querySelectorAll(sel));
  const $ = (sel, ctx = document) => ctx.querySelector(sel);

  function resetPopupViews() {
    views.confirmSubscribe.classList.add('hidden');
    views.confirmUnsubscribe.classList.add('hidden');
    views.successSubscribe.classList.remove('active');
    views.successUnsubscribe.classList.remove('active');
  }

  function closePopup() {
    overlay.classList.remove('active');
    resetPopupViews();
    activeCheckbox = null;
  }

  function openPopup(isSubscribing) {
    resetPopupViews();
    (isSubscribing ? views.confirmSubscribe : views.confirmUnsubscribe)
      .classList.remove('hidden');
    overlay.classList.add('active');
  }

  function applyCheckboxState(checkbox, checked) {
    checkbox.checked = checked;
    checkbox.dispatchEvent(new Event('change', { bubbles: true }));
  }

  // ---------- "All sports" sync ----------
  function getSportCheckboxes() {
    return $$('.sport-preference-checkbox');
  }

  function syncAllSportsCheckbox() {
    if (syncing) return;
    const allCheckbox = $('.sport-all-checkbox');
    const sports = getSportCheckboxes();
    if (!allCheckbox || sports.length === 0) return;

    syncing = true;
    const allChecked = sports.every((cb) => cb.checked);
    allCheckbox.checked = allChecked;
    syncing = false;
  }

  function toggleAllSports(checked) {
    syncing = true;
    $('.sport-all-checkbox').checked = checked;
    getSportCheckboxes().forEach((cb) => {
      if (cb.checked !== checked) {
        cb.checked = checked;
        cb.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
    syncing = false;
  }

  // ---------- Webhook ----------
  function getCheckedSportKeys() {
    return getSportCheckboxes()
      .filter((cb) => cb.checked)
      .map((cb) => cb.dataset.preferenceKey)
      .filter(Boolean);
  }

  function sendSportPreferencesWebhook() {
    if (!CONFIG.webhookUrl || !CONFIG.email) return;

    const payload = {
      gid: CONFIG.customerGid,
      email: CONFIG.email,
      region: CONFIG.region,
      interests: getCheckedSportKeys(),
    };

    fetch(CONFIG.webhookUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
      keepalive: true,
    }).catch((err) => {
      console.warn('[CustomerPreferences] webhook failed', err);
    });
  }

  function scheduleWebhook() {
    clearTimeout(webhookTimer);
    webhookTimer = setTimeout(sendSportPreferencesWebhook, DEBOUNCE_MS);
  }

  // ---------- Popup confirmation flow ----------
  function handleMarketingCheckboxIntercept(e) {
    const checkbox = e.currentTarget;

    if (checkbox.disabled) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      return;
    }

    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    const willBecomeChecked = !checkbox.checked;

    if (!CONFIG.popupEnabled) {
      applyCheckboxStateAndPersist(checkbox, willBecomeChecked);
      return;
    }

    activeCheckbox = checkbox;
    pendingSubscribing = willBecomeChecked;
    openPopup(willBecomeChecked);
  }

  function handleLabelClick(e) {
    const forId = e.currentTarget.getAttribute('for');
    if (!forId) return;
    const checkbox = document.getElementById(forId);
    if (!checkbox || checkbox.disabled) return;

    e.preventDefault();
    e.stopPropagation();
    handleMarketingCheckboxIntercept({
      currentTarget: checkbox,
      preventDefault: () => {},
      stopPropagation: () => {},
      stopImmediatePropagation: () => {},
    });
  }

  // ---------- Marketing change handler ----------
  function getMarketingState() {
    const channels = { sms: null, email: null };
    $$('[data-preference-channel]').forEach((cb) => {
      const channel = cb.dataset.preferenceChannel;
      if (channel === 'sms' || channel === 'email') {
        // Disabled SMS (no phone on file) always reports false
        channels[channel] = cb.disabled ? false : cb.checked;
      }
    });
    return channels;
  }

  function onMarketingChange(checkbox) {
    const key = checkbox.dataset.preferenceKey || '';
    const channel = checkbox.dataset.preferenceChannel || '';
    const subscribed = checkbox.checked;

    // Let other scripts observe individual changes
    document.dispatchEvent(new CustomEvent('preferences:marketing-change', {
      detail: { key, channel, subscribed, email: CONFIG.email, region: CONFIG.region },
    }));

    persistMarketingPreferences();
  }

  function persistMarketingPreferences() {
    if (!CONFIG.marketingWebhookUrl || !CONFIG.customerGid) {
      console.warn('[CustomerPreferences] marketing webhook misconfigured');
      return;
    }

    const state = getMarketingState();
    const payload = {
      gid: CONFIG.customerGid,
      email: CONFIG.email,
      smsSubscribe: state.sms === true,
      emailSubscribe: state.email === true,
      region: CONFIG.region,
    };

    fetch(CONFIG.marketingWebhookUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
      keepalive: true,
    }).catch((err) => {
      console.warn('[CustomerPreferences] marketing webhook failed', err);
    });
  }

  function applyCheckboxStateAndPersist(checkbox, checked) {
    applyCheckboxState(checkbox, checked);
    onMarketingChange(checkbox);
  }

  function confirmPopup() {
    if (!activeCheckbox) return;
    applyCheckboxStateAndPersist(activeCheckbox, pendingSubscribing);

    resetPopupViews();
    (pendingSubscribing ? views.successSubscribe : views.successUnsubscribe)
      .classList.add('active');

    setTimeout(closePopup, 2000);
  }

  // ---------- Phone editor ----------
  function isValidPhoneFormat(value) {
    if (!value || typeof value !== 'string') return false;
    const trimmed = value.trim();
    if (!/^[+()\-\s\d.]+$/.test(trimmed)) return false;
    const digitCount = (trimmed.match(/\d/g) || []).length;
    return digitCount >= 7 && digitCount <= 15;
  }

  function setupPhoneEditor() {
    const editor = $('[data-phone-editor]');
    if (!editor) return;

    const display = editor.querySelector('[data-phone-display]');
    const form = editor.querySelector('[data-phone-form]');
    const input = editor.querySelector('[data-phone-input]');
    const saveBtn = editor.querySelector('[data-phone-save]');
    const cancelBtn = editor.querySelector('[data-phone-cancel]');
    const errorEl = editor.querySelector('[data-phone-error]');
    const displayValue = editor.querySelector('.phone-editor-display-value');
    const hintEl = editor.parentElement
      ? editor.parentElement.querySelector('[data-phone-hint]')
      : null;

    if (!display || !form || !input || !saveBtn || !cancelBtn) return;

    function showError(msg) {
      errorEl.textContent = msg;
      errorEl.hidden = false;
      input.classList.add('is-invalid');
      input.setAttribute('aria-invalid', 'true');
    }

    function clearError() {
      errorEl.textContent = '';
      errorEl.hidden = true;
      input.classList.remove('is-invalid');
      input.removeAttribute('aria-invalid');
    }

    function openEditor() {
      display.hidden = true;
      form.hidden = false;
      input.value = editor.dataset.currentPhone || '';
      clearError();
      input.focus();
      input.select();
    }

    function closeEditor() {
      form.hidden = true;
      display.hidden = false;
      clearError();
    }

    function updateSmsCheckboxAvailability(hasPhone) {
      $$('input[data-preference-channel="sms"]').forEach((cb) => {
        const wrapper = cb.closest('.preference-block-wrapper');
        if (hasPhone) {
          cb.disabled = false;
          cb.removeAttribute('aria-disabled');
          if (wrapper) wrapper.classList.remove('is-disabled');
        }
      });
      if (hintEl) {
        hintEl.textContent = hasPhone
          ? 'Click to edit your phone number'
          : 'Add a phone number to enable SMS preferences';
      }
    }

    function getCurrentSmsSubscribeState() {
      const smsCb = $('input[data-preference-channel="sms"]');
      if (!smsCb) return false;
      return smsCb.disabled ? false : smsCb.checked;
    }

    async function savePhone() {
      const newPhone = input.value.trim();

      if (!newPhone) {
        showError('Please enter a phone number.');
        return;
      }
      if (!isValidPhoneFormat(newPhone)) {
        showError('Please enter a valid phone number (digits, spaces, and + - ( ) only).');
        return;
      }
      if (!CONFIG.phoneWebhookUrl || !CONFIG.customerGid) {
        showError('Phone update is not available right now.');
        console.warn('[CustomerPreferences] phone webhook misconfigured');
        return;
      }

      saveBtn.setAttribute('aria-busy', 'true');
      saveBtn.disabled = true;
      clearError();

      const payload = {
        gid: CONFIG.customerGid,
        smsSubscribe: getCurrentSmsSubscribeState(),
        phone: newPhone,
        region: CONFIG.region,
      };

      try {
        const res = await fetch(CONFIG.phoneWebhookUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload),
          keepalive: true,
        });

        if (!res.ok) throw new Error('HTTP ' + res.status);

        editor.dataset.currentPhone = newPhone;
        if (displayValue) displayValue.textContent = newPhone;
        updateSmsCheckboxAvailability(true);

        document.dispatchEvent(new CustomEvent('preferences:phone-updated', {
          detail: { phone: newPhone, customerGid: CONFIG.customerGid },
        }));

        closeEditor();
      } catch (err) {
        console.warn('[CustomerPreferences] phone webhook failed', err);
        showError('Could not save your phone number. Please try again.');
      } finally {
        saveBtn.removeAttribute('aria-busy');
        saveBtn.disabled = false;
      }
    }

    display.addEventListener('click', openEditor);
    cancelBtn.addEventListener('click', closeEditor);
    saveBtn.addEventListener('click', savePhone);

    input.addEventListener('input', clearError);
    input.addEventListener('keydown', (e) => {
      if (e.key === 'Enter') {
        e.preventDefault();
        savePhone();
      } else if (e.key === 'Escape') {
        e.preventDefault();
        closeEditor();
      }
    });
  }

  // ---------- Wire-up ----------
  function init() {
    // Phone number editor
    setupPhoneEditor();

    // Marketing checkboxes
    $$('.preference-checkbox input[type="checkbox"]').forEach((cb) => {
      cb.addEventListener('mousedown', handleMarketingCheckboxIntercept, true);
    });
    $$('.preference-label').forEach((label) => {
      label.addEventListener('mousedown', handleLabelClick, true);
    });

    // Sport checkboxes (no popup, fire webhook)
    getSportCheckboxes().forEach((cb) => {
      cb.addEventListener('change', () => {
        if (!syncing) {
          syncAllSportsCheckbox();
          scheduleWebhook();
        }
      });
    });

    // "All sports" toggle
    const allSports = $('.sport-all-checkbox');
    const allWrapper = $('.sport-all-checkbox-wrapper');
    if (allSports && allWrapper) {
      allSports.addEventListener('change', (e) => {
        if (syncing) return;
        toggleAllSports(e.target.checked);
        scheduleWebhook();
      });

      syncAllSportsCheckbox();
    }

    // Popup buttons
    const bindClose = (el) => el && el.addEventListener('click', (e) => {
      e.preventDefault();
      closePopup();
    });
    const bindConfirm = (el) => el && el.addEventListener('click', (e) => {
      e.preventDefault();
      confirmPopup();
    });

    bindConfirm($('#preference-popup-yes-subscribe'));
    bindConfirm($('#preference-popup-yes-unsubscribe'));
    bindClose($('#preference-popup-no-subscribe'));
    bindClose($('#preference-popup-no-unsubscribe'));
    bindClose($('#preference-popup-close'));

    overlay.addEventListener('click', (e) => {
      if (e.target === overlay) closePopup();
    });

    // Flush pending webhook on page unload
    window.addEventListener('pagehide', () => {
      if (webhookTimer) {
        clearTimeout(webhookTimer);
        sendSportPreferencesWebhook();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
